export default {
  logoTitle: 'iA Financial Group',
};
